import { render } from "./Guest.vue?vue&type=template&id=2fae207d"
import script from "./Guest.vue?vue&type=script&lang=js"
export * from "./Guest.vue?vue&type=script&lang=js"
script.render = render

export default script